import { render } from "./TogglePrimaryActive.vue?vue&type=template&id=74606120&scoped=true"
import script from "./TogglePrimaryActive.vue?vue&type=script&lang=js"
export * from "./TogglePrimaryActive.vue?vue&type=script&lang=js"

import "./TogglePrimaryActive.vue?vue&type=style&index=0&id=74606120&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74606120"]])

export default __exports__